import { isComplete, isError } from '../../common/providers/as-data-provider';
import {
	type AvailableProductLinks,
	type AvailableLink,
	type ProviderResults,
	type ProductConfigurationResponse,
} from '../../types';
import { type SwitcherItemType } from '../../common/utils/links';

export function getProductLink(
	link: AvailableLink,
	productConfigurationResponse: ProductConfigurationResponse,
	adminUrl: string | undefined,
	keySuffix: number | string,
): AvailableProductLinks | null {
	const productConfigItem = productConfigurationResponse.links[link.linkType];
	if (productConfigItem) {
		const href =
			adminUrl && link.linkType.toLowerCase() === 'administration'
				? adminUrl
				: link.url || productConfigItem.href;
		return {
			...productConfigItem,
			key: productConfigItem.key + keySuffix,
			href,
		};
	}
	return null;
}

export function collectAdminLinks(
	availableProducts: ProviderResults['availableProducts'],
	productConfiguration: ProviderResults['productConfiguration'],
	adminUrl?: string,
): SwitcherItemType[] {
	if (isError(availableProducts) || isError(productConfiguration)) {
		return [];
	}
	if (
		isComplete(availableProducts) &&
		availableProducts.data &&
		isComplete(productConfiguration) &&
		productConfiguration.data
	) {
		return availableProducts.data.links
			.reduce<AvailableProductLinks[]>((acc, link, i) => {
				const productLink = getProductLink(link, productConfiguration.data, adminUrl, i);

				if (productLink) {
					acc.push(productLink);
				}

				return acc;
			}, [])
			.sort((a, b) => a.ordinal - b.ordinal);
	}

	return [];
}
